let map = null;
let mapReady = false;
let currentTheme = THEMES.architect_draft || Object.values(THEMES)[0];
let currentPreset = MARATHON_LIBRARY.london_marathon_2026;
let currentSize = { label: 'A3', w: 29.7, h: 42, ratio: 0.7071 };
let customPreset = null;
let distanceUnit = 'miles';

const routeStyle = {
  color: null,
  width: 4.25,
  glow: 8,
  padding: 82,
  showSplits: false,
};

const typography = {
  font: 'Inter',
  color: null,
};

const DISTANCE_UNITS = {
  miles: { label: 'Miles', short: 'MI', splitLabel: '5-mile', intervalKm: 8.04672, decimals: 1 },
  km: { label: 'Kilometres', short: 'KM', splitLabel: '5K', intervalKm: 5, decimals: 1 },
};

const els = {
  routePreset: document.getElementById('route-preset'),
  routeUpload: document.getElementById('route-upload'),
  routeUploadClear: document.getElementById('route-upload-clear'),
  presetName: document.getElementById('preset-name'),
  presetDescription: document.getElementById('preset-description'),
  themeGrid: document.getElementById('theme-grid'),
  themeName: document.getElementById('theme-name-display'),
  themeSuggestionRow: document.getElementById('theme-suggestion-row'),
  routeColor: document.getElementById('route-colour'),
  routeColorReset: document.getElementById('route-colour-reset'),
  routeWidth: document.getElementById('route-width'),
  routeWidthVal: document.getElementById('route-width-val'),
  routeGlow: document.getElementById('route-glow'),
  routeGlowVal: document.getElementById('route-glow-val'),
  routePadding: document.getElementById('route-padding'),
  routePaddingVal: document.getElementById('route-padding-val'),
  showSplits: document.getElementById('show-splits'),
  splitToggleLabel: document.getElementById('split-toggle-label'),
  distanceUnit: document.getElementById('distance-unit'),
  eventTitle: document.getElementById('event-title'),
  eventSubtitle: document.getElementById('event-subtitle'),
  runnerName: document.getElementById('runner-name'),
  bibNumber: document.getElementById('bib-number'),
  finishTime: document.getElementById('finish-time'),
  charityName: document.getElementById('charity-name'),
  fontSelect: document.getElementById('font-select'),
  textColor: document.getElementById('text-colour'),
  textColorReset: document.getElementById('text-colour-reset'),
  shareBtn: document.getElementById('share-btn'),
  buyBtn: document.getElementById('buy-btn'),
  enquireBtn: document.getElementById('enquire-btn'),
  downloadBtn: document.getElementById('download-preview-btn'),
  marathonTitle: document.getElementById('marathon-title'),
  marathonSubtitle: document.getElementById('marathon-subtitle'),
  runnerBadge: document.getElementById('runner-badge'),
  metaBadge: document.getElementById('meta-badge'),
  charityBadge: document.getElementById('charity-badge'),
  marathonAttrib: document.getElementById('marathon-attrib'),
  posterFrame: document.getElementById('poster-frame'),
  statusBar: document.getElementById('status-bar'),
  copyToast: document.getElementById('copy-toast'),
};

function buildMapStyle(theme) {
  const t = theme;
  return {
    version: 8,
    sources: {
      ofm: {
        type: 'vector',
        url: 'https://tiles.openfreemap.org/planet',
      },
    },
    layers: [
      { id: 'background', type: 'background', paint: { 'background-color': t.bg } },
      {
        id: 'landuse-green',
        type: 'fill',
        source: 'ofm',
        'source-layer': 'landuse',
        filter: ['in', ['get', 'class'], ['literal', ['park', 'garden', 'grass', 'meadow', 'pitch', 'cemetery', 'allotments', 'forest', 'wood']]],
        paint: { 'fill-color': t.parks, 'fill-opacity': 1 },
      },
      {
        id: 'landcover-green',
        type: 'fill',
        source: 'ofm',
        'source-layer': 'landcover',
        filter: ['in', ['get', 'class'], ['literal', ['grass', 'wood', 'scrub', 'farmland']]],
        paint: { 'fill-color': t.parks, 'fill-opacity': 0.7 },
      },
      {
        id: 'water-fill',
        type: 'fill',
        source: 'ofm',
        'source-layer': 'water',
        paint: { 'fill-color': t.water, 'fill-opacity': 1 },
      },
      {
        id: 'waterway-line',
        type: 'line',
        source: 'ofm',
        'source-layer': 'waterway',
        paint: {
          'line-color': t.waterway || t.water,
          'line-width': ['interpolate', ['linear'], ['zoom'], 9, 0.5, 14, 2.2],
        },
      },
      {
        id: 'building-fill',
        type: 'fill',
        source: 'ofm',
        'source-layer': 'building',
        minzoom: 12,
        paint: { 'fill-color': t.buildings || t.bg, 'fill-opacity': 0.92 },
      },
      {
        id: 'road-minor',
        type: 'line',
        source: 'ofm',
        'source-layer': 'transportation',
        filter: ['in', ['get', 'class'], ['literal', ['minor', 'service', 'track', 'path', 'residential']]],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
          'line-color': t.road_residential,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.4, 14, 1.5],
        },
      },
      {
        id: 'road-tertiary',
        type: 'line',
        source: 'ofm',
        'source-layer': 'transportation',
        filter: ['==', ['get', 'class'], 'tertiary'],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
          'line-color': t.road_tertiary,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.7, 14, 2.5],
        },
      },
      {
        id: 'road-secondary',
        type: 'line',
        source: 'ofm',
        'source-layer': 'transportation',
        filter: ['==', ['get', 'class'], 'secondary'],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
          'line-color': t.road_secondary,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1, 14, 3.5],
        },
      },
      {
        id: 'road-primary',
        type: 'line',
        source: 'ofm',
        'source-layer': 'transportation',
        filter: ['in', ['get', 'class'], ['literal', ['primary', 'trunk']]],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
          'line-color': t.road_primary,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 5],
        },
      },
      {
        id: 'road-motorway',
        type: 'line',
        source: 'ofm',
        'source-layer': 'transportation',
        filter: ['==', ['get', 'class'], 'motorway'],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
          'line-color': t.road_motorway,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 2, 14, 7],
        },
      },
      {
        id: 'railway',
        type: 'line',
        source: 'ofm',
        'source-layer': 'transportation',
        filter: ['in', ['get', 'class'], ['literal', ['rail', 'transit']]],
        layout: { 'line-cap': 'butt', 'line-join': 'miter' },
        paint: {
          'line-color': t.road_tertiary || t.road_secondary,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.5, 14, 1.5],
          'line-dasharray': [3, 2],
        },
      },
    ],
  };
}

function formatNumber(value, decimals = 0) {
  return Number(value).toFixed(decimals);
}

function getDistanceUnitConfig(unit = distanceUnit) {
  return DISTANCE_UNITS[unit] || DISTANCE_UNITS.miles;
}

function formatDistance(distanceKm, unit = distanceUnit) {
  const config = getDistanceUnitConfig(unit);
  const value = unit === 'miles' ? distanceKm * 0.621371 : distanceKm;
  return `${formatNumber(value, config.decimals)} ${config.short}`;
}

function slugify(value) {
  return String(value || 'custom-route')
    .toLowerCase()
    .replace(/\.[^.]+$/, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || 'custom_route';
}

function getPresetById(id) {
  if (customPreset && customPreset.id === id) return customPreset;
  return MARATHON_LIBRARY[id] || null;
}

function showStatus(message, duration = 2200) {
  els.statusBar.textContent = message;
  els.statusBar.classList.add('visible');
  window.clearTimeout(showStatus.timer);
  showStatus.timer = window.setTimeout(() => {
    els.statusBar.classList.remove('visible');
  }, duration);
}

function showToast(message) {
  els.copyToast.textContent = message;
  els.copyToast.classList.add('visible');
  window.clearTimeout(showToast.timer);
  showToast.timer = window.setTimeout(() => {
    els.copyToast.classList.remove('visible');
  }, 2600);
}

function getOverlayTextColor() {
  return typography.color || currentTheme.text;
}

function syncOverlayChrome() {
  const color = getOverlayTextColor();
  const overlay = document.getElementById('marathon-overlay');
  overlay.style.setProperty('--overlay-text', color);
  overlay.style.setProperty('--badge-bg', (currentTheme.bg || '#111111') + 'A6');
  overlay.style.setProperty('--overlay-top', (currentTheme.bg || '#111111') + 'BF');
  overlay.style.setProperty('--overlay-bottom', (currentTheme.gradient_color || currentTheme.bg || '#111111') + 'B3');
}

function renderThemeGrid() {
  els.themeGrid.innerHTML = '';
  Object.values(THEMES).forEach((theme) => {
    const swatch = document.createElement('button');
    swatch.className = 'theme-swatch';
    swatch.type = 'button';
    swatch.dataset.id = theme.id;
    swatch.title = theme.name;
    swatch.innerHTML = `
      <div class="theme-swatch-inner">
        <div class="swatch-bg" style="background:${theme.bg};flex:1"></div>
        <div class="swatch-road" style="background:${theme.route_color || theme.road_motorway}"></div>
      </div>
      <div class="swatch-label">${theme.name}</div>
    `;
    swatch.addEventListener('click', () => selectTheme(theme.id));
    els.themeGrid.appendChild(swatch);
  });
}

function updateSuggestedThemes() {
  const suggested = currentPreset.suggestedThemes || [];
  els.themeSuggestionRow.innerHTML = '';
  document.querySelectorAll('.theme-swatch').forEach((swatch) => {
    swatch.classList.toggle('suggested', suggested.includes(swatch.dataset.id));
    const oldPill = swatch.querySelector('.suggest-pill');
    if (oldPill) oldPill.remove();
    if (suggested.includes(swatch.dataset.id)) {
      const pill = document.createElement('span');
      pill.className = 'suggest-pill';
      pill.textContent = 'Nice';
      swatch.appendChild(pill);
    }
  });

  suggested.forEach((id) => {
    const tag = document.createElement('span');
    tag.className = 'chip';
    tag.textContent = THEMES[id]?.name || id;
    els.themeSuggestionRow.appendChild(tag);
  });
}

function highlightTheme() {
  document.querySelectorAll('.theme-swatch').forEach((swatch) => {
    swatch.classList.toggle('active', swatch.dataset.id === currentTheme.id);
  });
  els.themeName.textContent = currentTheme.name;
  updateSuggestedThemes();
}

function selectTheme(id) {
  if (!THEMES[id]) return;
  currentTheme = THEMES[id];
  if (!routeStyle.color) {
    els.routeColor.value = currentTheme.route_color || '#e53935';
  }
  highlightTheme();
  applyTheme();
  updateOverlay();
  scheduleHashUpdate();
}

function applyTheme() {
  if (!mapReady) return;
  const t = currentTheme;
  const updates = [
    ['background', 'background-color', t.bg],
    ['landuse-green', 'fill-color', t.parks],
    ['landcover-green', 'fill-color', t.parks],
    ['water-fill', 'fill-color', t.water],
    ['waterway-line', 'line-color', t.waterway || t.water],
    ['building-fill', 'fill-color', t.buildings || t.bg],
    ['road-minor', 'line-color', t.road_residential],
    ['road-tertiary', 'line-color', t.road_tertiary],
    ['road-secondary', 'line-color', t.road_secondary],
    ['road-primary', 'line-color', t.road_primary],
    ['road-motorway', 'line-color', t.road_motorway],
    ['railway', 'line-color', t.road_tertiary || t.road_secondary],
  ];

  updates.forEach(([layer, prop, value]) => {
    try { map.setPaintProperty(layer, prop, value); } catch (_) {}
  });

  updateRoutePaint();
  syncOverlayChrome();
}

function haversineKm(a, b) {
  const toRad = Math.PI / 180;
  const dLat = (b[1] - a[1]) * toRad;
  const dLon = (b[0] - a[0]) * toRad;
  const lat1 = a[1] * toRad;
  const lat2 = b[1] * toRad;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 6371 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}

function interpolatePoint(a, b, fraction) {
  return [
    a[0] + (b[0] - a[0]) * fraction,
    a[1] + (b[1] - a[1]) * fraction,
  ];
}

function calculateRouteDistance(coords) {
  let distance = 0;
  for (let i = 1; i < coords.length; i += 1) {
    distance += haversineKm(coords[i - 1], coords[i]);
  }
  return distance;
}

function buildSplitFeatures(coords, totalDistanceKm, intervalKm = getDistanceUnitConfig().intervalKm) {
  if (!coords.length) return [];
  const features = [];
  let nextTarget = intervalKm;
  let travelled = 0;
  const maxSplit = Math.max(intervalKm, Math.floor(totalDistanceKm / intervalKm) * intervalKm);
  const half = totalDistanceKm >= 30 ? totalDistanceKm / 2 : null;
  let halfAdded = !half;

  for (let i = 1; i < coords.length; i += 1) {
    const segment = haversineKm(coords[i - 1], coords[i]);
    const prev = travelled;
    travelled += segment;

    while (nextTarget < maxSplit && travelled >= nextTarget && segment > 0) {
      const fraction = (nextTarget - prev) / segment;
      const labelValue = distanceUnit === 'miles'
        ? Math.round(nextTarget * 0.621371)
        : Math.round(nextTarget);
      features.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: interpolatePoint(coords[i - 1], coords[i], fraction) },
        properties: { label: distanceUnit === 'miles' ? `${labelValue}M` : `${labelValue}K`, kind: 'split' },
      });
      nextTarget += intervalKm;
    }

    if (!halfAdded && travelled >= half && segment > 0) {
      const fraction = (half - prev) / segment;
      features.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: interpolatePoint(coords[i - 1], coords[i], fraction) },
        properties: { label: 'HALF', kind: 'half' },
      });
      halfAdded = true;
    }
  }

  return features;
}

function routeLineGeoJSON() {
  return {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: currentPreset.coordinates,
      },
      properties: {
        name: currentPreset.name,
      },
    }],
  };
}

function routePointGeoJSON() {
  const coords = currentPreset.coordinates;
  const start = coords[0];
  const finish = coords[coords.length - 1];
  const features = [
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: start },
      properties: { kind: 'start', label: 'START' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: finish },
      properties: { kind: 'finish', label: 'FINISH' },
    },
  ];

  if (routeStyle.showSplits) {
    features.push(...buildSplitFeatures(coords, currentPreset.distanceKm || calculateRouteDistance(coords)));
  }

  return { type: 'FeatureCollection', features };
}

function updateRouteSources() {
  if (!mapReady) return;
  map.getSource('marathon-route')?.setData(routeLineGeoJSON());
  map.getSource('marathon-points')?.setData(routePointGeoJSON());
}

function updateRoutePaint() {
  if (!mapReady) return;
  const routeColor = routeStyle.color || currentTheme.route_color || '#e53935';
  const glowColor = currentTheme.route_highlight || routeColor;

  map.setPaintProperty('route-glow', 'line-color', glowColor);
  map.setPaintProperty('route-glow', 'line-width', routeStyle.width + routeStyle.glow);
  map.setPaintProperty('route-glow', 'line-opacity', routeStyle.glow > 0 ? 0.34 : 0);
  map.setPaintProperty('route-line', 'line-color', routeColor);
  map.setPaintProperty('route-line', 'line-width', routeStyle.width);
  map.setPaintProperty('route-line', 'line-opacity', 0.96);
  map.setPaintProperty('route-point-halo', 'circle-color', '#ffffff');
  map.setPaintProperty('route-point-fill', 'circle-color', [
    'match',
    ['get', 'kind'],
    'start', currentTheme.start_color || '#43a047',
    'finish', currentTheme.finish_color || '#e53935',
    'half', routeColor,
    currentTheme.text,
  ]);
  const pointFilter = routeStyle.showSplits
    ? ['in', ['get', 'kind'], ['literal', ['start', 'finish', 'half', 'split']]]
    : ['in', ['get', 'kind'], ['literal', ['start', 'finish', 'half']]];
  map.setFilter('route-point-halo', pointFilter);
  map.setFilter('route-point-fill', pointFilter);
}

function getBoundsFromCoords(coords) {
  const bounds = new maplibregl.LngLatBounds(coords[0], coords[0]);
  coords.forEach((coord) => bounds.extend(coord));
  return bounds;
}

function fitRoute() {
  if (!mapReady || !currentPreset.coordinates.length) return;
  map.fitBounds(getBoundsFromCoords(currentPreset.coordinates), {
    padding: routeStyle.padding,
    duration: 0,
  });
}

function updateUploadUi() {
  els.routeUploadClear.style.display = customPreset ? '' : 'none';
}

function updateDistanceUi() {
  const config = getDistanceUnitConfig();
  if (els.distanceUnit) els.distanceUnit.value = distanceUnit;
  if (els.splitToggleLabel) {
    els.splitToggleLabel.textContent = `Show ${config.splitLabel} split markers`;
  }
}

function setRoutePreset(presetId, fit = true) {
  const preset = getPresetById(presetId);
  if (!preset) return;
  currentPreset = preset;
  els.routePreset.value = presetId;
  els.presetName.textContent = currentPreset.name;
  els.presetDescription.textContent = currentPreset.description;

  if (!els.eventTitle.dataset.userEdited) {
    els.eventTitle.value = currentPreset.name;
  }
  if (!els.eventSubtitle.dataset.userEdited) {
    els.eventSubtitle.value = `${currentPreset.subtitle} | ${currentPreset.date}`;
  }

  updateRouteSources();
  updateOverlay();
  if (fit) fitRoute();
  highlightTheme();
  showStatus(`${currentPreset.name} loaded`);
  scheduleHashUpdate();
}

function updateOverlay() {
  const title = els.eventTitle.value.trim() || currentPreset.name;
  const subtitle = els.eventSubtitle.value.trim() || `${currentPreset.subtitle} | ${currentPreset.date}`;
  const runnerName = els.runnerName.value.trim() || 'Runner Name';
  const bib = els.bibNumber.value.trim();
  const finishTime = els.finishTime.value.trim();
  const charity = els.charityName.value.trim();
  const textColor = getOverlayTextColor();

  els.marathonTitle.textContent = title.toUpperCase();
  els.marathonSubtitle.textContent = subtitle.toUpperCase();
  els.runnerBadge.innerHTML = `<strong>${runnerName.toUpperCase()}</strong>`;

  const metaParts = [formatDistance(currentPreset.distanceKm)];
  if (bib) metaParts.push(`BIB ${bib}`);
  if (finishTime) metaParts.push(finishTime);
  els.metaBadge.innerHTML = `<span>${metaParts.join(' | ')}</span>`;
  els.metaBadge.style.display = metaParts.length ? '' : 'none';

  if (charity) {
    els.charityBadge.innerHTML = `<span>${charity}</span>`;
    els.charityBadge.style.display = '';
  } else {
    els.charityBadge.style.display = 'none';
  }

  els.marathonTitle.style.fontFamily = `'${typography.font}', system-ui, sans-serif`;
  els.marathonSubtitle.style.fontFamily = `'${typography.font}', system-ui, sans-serif`;
  els.runnerBadge.style.fontFamily = `'${typography.font}', system-ui, sans-serif`;
  els.metaBadge.style.fontFamily = `'${typography.font}', system-ui, sans-serif`;
  els.charityBadge.style.fontFamily = `'${typography.font}', system-ui, sans-serif`;
  els.marathonAttrib.style.color = textColor;
  syncOverlayChrome();
}

function updateLayout() {
  const orient = document.querySelector('.orient-btn.active')?.dataset.orient || 'landscape';
  const ratio = orient === 'landscape'
    ? currentSize.h / currentSize.w
    : currentSize.w / currentSize.h;

  els.posterFrame.style.aspectRatio = `${ratio}`;
  els.posterFrame.style.height = `min(calc(100vh - 48px), calc((100vw - var(--sidebar-w) - 48px) / ${ratio}))`;

  window.requestAnimationFrame(() => {
    if (mapReady) {
      map.resize();
      fitRoute();
    }
  });
}

function renderPresetOptions() {
  els.routePreset.innerHTML = '';
  const presets = [...Object.values(MARATHON_LIBRARY)];
  if (customPreset) presets.push(customPreset);

  presets.forEach((preset) => {
    const option = document.createElement('option');
    option.value = preset.id;
    option.textContent = preset.isCustom ? `${preset.name} (Upload)` : preset.name;
    els.routePreset.appendChild(option);
  });

  updateUploadUi();
}

function renderMap() {
  map = new maplibregl.Map({
    container: 'map',
    style: buildMapStyle(currentTheme),
    center: [currentPreset.coordinates[0][0], currentPreset.coordinates[0][1]],
    zoom: 11,
    attributionControl: false,
    preserveDrawingBuffer: true,
  });

  map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');

  map.on('load', () => {
    mapReady = true;

    map.addSource('marathon-route', {
      type: 'geojson',
      data: routeLineGeoJSON(),
    });

    map.addSource('marathon-points', {
      type: 'geojson',
      data: routePointGeoJSON(),
    });

    map.addLayer({
      id: 'route-glow',
      type: 'line',
      source: 'marathon-route',
      layout: { 'line-cap': 'round', 'line-join': 'round' },
      paint: {
        'line-color': currentTheme.route_highlight || currentTheme.route_color || '#ff6f60',
        'line-width': routeStyle.width + routeStyle.glow,
        'line-opacity': 0.34,
        'line-blur': 2,
      },
    });

    map.addLayer({
      id: 'route-line',
      type: 'line',
      source: 'marathon-route',
      layout: { 'line-cap': 'round', 'line-join': 'round' },
      paint: {
        'line-color': currentTheme.route_color || '#e53935',
        'line-width': routeStyle.width,
        'line-opacity': 0.96,
      },
    });

    map.addLayer({
      id: 'route-point-halo',
      type: 'circle',
      source: 'marathon-points',
      paint: {
        'circle-radius': ['match', ['get', 'kind'], 'split', 10, 'half', 11, 9],
        'circle-color': '#ffffff',
      },
    });

    map.addLayer({
      id: 'route-point-fill',
      type: 'circle',
      source: 'marathon-points',
      paint: {
        'circle-radius': ['match', ['get', 'kind'], 'split', 7, 'half', 8, 6],
        'circle-color': ['match', ['get', 'kind'], 'start', currentTheme.start_color || '#43a047', 'finish', currentTheme.finish_color || '#e53935', 'half', currentTheme.route_color || '#e53935', currentTheme.text],
      },
    });

    updateRoutePaint();
    updateOverlay();
    updateLayout();
    fitRoute();
    showStatus('Marathon builder ready');
  });

  window.addEventListener('resize', () => {
    if (!mapReady) return;
    map.resize();
    fitRoute();
  });
}

function serialiseState() {
  return {
    preset: currentPreset.isCustom ? null : currentPreset.id,
    theme: currentTheme.id,
    routeColor: routeStyle.color,
    routeWidth: routeStyle.width,
    routeGlow: routeStyle.glow,
    routePadding: routeStyle.padding,
    showSplits: routeStyle.showSplits,
    title: els.eventTitle.value.trim(),
    subtitle: els.eventSubtitle.value.trim(),
    runner: els.runnerName.value.trim(),
    bib: els.bibNumber.value.trim(),
    finish: els.finishTime.value.trim(),
    charity: els.charityName.value.trim(),
    font: typography.font,
    textColor: typography.color,
    distanceUnit,
    size: currentSize.label,
    orient: document.querySelector('.orient-btn.active')?.dataset.orient || 'landscape',
  };
}

function encodeState() {
  return btoa(unescape(encodeURIComponent(JSON.stringify(serialiseState()))))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function decodeState(hash) {
  try {
    const raw = hash.replace(/^#/, '').replace(/-/g, '+').replace(/_/g, '/');
    const padded = raw + '='.repeat((4 - raw.length % 4) % 4);
    return JSON.parse(decodeURIComponent(escape(atob(padded))));
  } catch (_) {
    return null;
  }
}

function scheduleHashUpdate() {
  window.clearTimeout(scheduleHashUpdate.timer);
  scheduleHashUpdate.timer = window.setTimeout(() => {
    if (currentPreset.isCustom) {
      history.replaceState(null, '', location.pathname);
      return;
    }
    history.replaceState(null, '', `#${encodeState()}`);
  }, 120);
}

function restoreState() {
  const state = decodeState(location.hash);
  if (!state) return;

  if (state.preset && getPresetById(state.preset)) {
    currentPreset = getPresetById(state.preset);
  }
  if (state.theme && THEMES[state.theme]) {
    currentTheme = THEMES[state.theme];
  }
  routeStyle.color = state.routeColor || null;
  routeStyle.width = Number(state.routeWidth || routeStyle.width);
  routeStyle.glow = Number(state.routeGlow || routeStyle.glow);
  routeStyle.padding = Number(state.routePadding || routeStyle.padding);
  routeStyle.showSplits = Boolean(state.showSplits);
  typography.font = state.font || typography.font;
  typography.color = state.textColor || null;
  distanceUnit = state.distanceUnit || 'miles';

  els.routeColor.value = routeStyle.color || currentTheme.route_color || '#e53935';
  els.routeWidth.value = routeStyle.width;
  els.routeGlow.value = routeStyle.glow;
  els.routePadding.value = routeStyle.padding;
  els.showSplits.checked = routeStyle.showSplits;
  els.routeWidthVal.textContent = formatNumber(routeStyle.width, 2);
  els.routeGlowVal.textContent = formatNumber(routeStyle.glow, 1);
  els.routePaddingVal.textContent = formatNumber(routeStyle.padding, 0);

  if (state.title) {
    els.eventTitle.value = state.title;
    els.eventTitle.dataset.userEdited = 'true';
  }
  if (state.subtitle) {
    els.eventSubtitle.value = state.subtitle;
    els.eventSubtitle.dataset.userEdited = 'true';
  }
  if (state.runner) els.runnerName.value = state.runner;
  if (state.bib) els.bibNumber.value = state.bib;
  if (state.finish) els.finishTime.value = state.finish;
  if (state.charity) els.charityName.value = state.charity;
  if (state.font) els.fontSelect.value = state.font;
  els.textColor.value = typography.color || currentTheme.text;

  if (state.size) {
    const match = [...document.querySelectorAll('.size-btn')].find((btn) => btn.dataset.label === state.size);
    if (match) {
      currentSize = {
        label: match.dataset.label,
        w: Number(match.dataset.w),
        h: Number(match.dataset.h),
        ratio: Number(match.dataset.ratio),
      };
    }
  }

  if (state.orient) {
    document.querySelectorAll('.orient-btn').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.orient === state.orient);
    });
  }

  updateDistanceUi();
}

function getRouteColor() {
  return routeStyle.color || currentTheme.route_color || '#e53935';
}

function drawRoundedRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function drawBadge(ctx, x, y, text, options = {}) {
  if (!text) return y;
  const font = options.font || `500 26px '${typography.font}', system-ui, sans-serif`;
  const textColor = options.textColor || getOverlayTextColor();
  ctx.font = font;
  const width = ctx.measureText(text).width + 28;
  const height = options.height || 42;
  ctx.save();
  ctx.fillStyle = options.bg || 'rgba(12, 12, 12, 0.55)';
  ctx.strokeStyle = options.stroke || 'rgba(255,255,255,0.14)';
  ctx.lineWidth = 1;
  drawRoundedRect(ctx, x, y, width, height, 8);
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = textColor;
  ctx.textBaseline = 'middle';
  ctx.fillText(text, x + 14, y + height / 2 + 1);
  ctx.restore();
  return y + height + 8;
}

async function renderPosterCanvas(includeWatermark = true) {
  const mapCanvas = map.getCanvas();
  const w = mapCanvas.width;
  const h = mapCanvas.height;
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(mapCanvas, 0, 0);

  const bgTop = `${currentTheme.bg || '#111111'}C6`;
  const bgBottom = `${(currentTheme.gradient_color || currentTheme.bg || '#111111')}C6`;

  let grad = ctx.createLinearGradient(0, 0, 0, h * 0.18);
  grad.addColorStop(0, bgTop);
  grad.addColorStop(1, `${currentTheme.bg || '#111111'}00`);
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, w, h * 0.24);

  grad = ctx.createLinearGradient(0, h, 0, h * 0.78);
  grad.addColorStop(0, bgBottom);
  grad.addColorStop(1, `${currentTheme.bg || '#111111'}00`);
  ctx.fillStyle = grad;
  ctx.fillRect(0, h * 0.7, w, h * 0.3);

  const textColor = getOverlayTextColor();
  ctx.textAlign = 'center';
  ctx.fillStyle = textColor;
  ctx.textBaseline = 'top';

  ctx.font = `600 ${Math.round(w * 0.044)}px '${typography.font}', system-ui, sans-serif`;
  ctx.fillText((els.eventTitle.value.trim() || currentPreset.name).toUpperCase(), w / 2, h * 0.036);

  ctx.globalAlpha = 0.84;
  ctx.font = `400 ${Math.round(w * 0.014)}px '${typography.font}', system-ui, sans-serif`;
  ctx.fillText((els.eventSubtitle.value.trim() || `${currentPreset.subtitle} | ${currentPreset.date}`).toUpperCase(), w / 2, h * 0.09);
  ctx.globalAlpha = 1;

  let badgeY = h * 0.915 - 120;
  const badgeX = w * 0.028;
  badgeY = drawBadge(ctx, badgeX, badgeY, (els.runnerName.value.trim() || 'Runner Name').toUpperCase(), {
    font: `600 ${Math.round(w * 0.014)}px '${typography.font}', system-ui, sans-serif`,
    textColor,
  });

  const meta = [formatDistance(currentPreset.distanceKm)];
  if (els.bibNumber.value.trim()) meta.push(`BIB ${els.bibNumber.value.trim()}`);
  if (els.finishTime.value.trim()) meta.push(els.finishTime.value.trim());
  badgeY = drawBadge(ctx, badgeX, badgeY, meta.join(' | '), {
    font: `500 ${Math.round(w * 0.012)}px '${typography.font}', system-ui, sans-serif`,
    textColor,
    height: 38,
  });

  if (els.charityName.value.trim()) {
    drawBadge(ctx, badgeX, badgeY, els.charityName.value.trim(), {
      font: `500 ${Math.round(w * 0.011)}px '${typography.font}', system-ui, sans-serif`,
      textColor,
      height: 36,
    });
  }

  ctx.textAlign = 'right';
  ctx.globalAlpha = 0.45;
  ctx.font = `400 ${Math.round(w * 0.008)}px Inter, system-ui, sans-serif`;
  ctx.fillText('PIGGERY OSM | © OpenStreetMap contributors', w * 0.978, h * 0.982);
  ctx.globalAlpha = 1;

  if (includeWatermark) {
    ctx.save();
    ctx.globalAlpha = 0.22;
    ctx.fillStyle = '#ffffff';
    ctx.font = `800 ${Math.round(w * 0.08)}px Inter, system-ui, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.translate(w / 2, h / 2);
    ctx.rotate(-35 * Math.PI / 180);
    ctx.fillText('PIGGERY PREVIEW', 0, 0);
    ctx.restore();
  }

  return canvas;
}

async function downloadPreview() {
  const btn = els.downloadBtn;
  btn.textContent = 'Generating…';
  btn.disabled = true;
  try {
    const canvas = await renderPosterCanvas(true);
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${currentPreset.id}-${currentTheme.id}-preview.png`;
      a.click();
      URL.revokeObjectURL(url);
      btn.textContent = '✓ Downloaded';
      setTimeout(() => {
        btn.textContent = '↓ Download Watermarked Preview';
        btn.disabled = false;
      }, 2200);
    }, 'image/png');
  } catch (error) {
    console.error(error);
    btn.textContent = '↓ Download Watermarked Preview';
    btn.disabled = false;
    showToast('Could not generate preview');
  }
}

function extractCoordinatePairs(text) {
  const coords = [];
  text.replace(/\n/g, ' ').split(/\s+/).forEach((coord) => {
    if (!coord) return;
    const parts = coord.split(',');
    if (parts.length < 2) return;
    const lon = Number(parts[0]);
    const lat = Number(parts[1]);
    if (Number.isFinite(lon) && Number.isFinite(lat)) {
      coords.push([lon, lat]);
    }
  });
  return coords;
}

function parseGpxText(text) {
  const xml = new DOMParser().parseFromString(text, 'application/xml');
  const trkpts = [...xml.getElementsByTagName('trkpt')];
  const coords = trkpts
    .map((trkpt) => [Number(trkpt.getAttribute('lon')), Number(trkpt.getAttribute('lat'))])
    .filter(([lon, lat]) => Number.isFinite(lon) && Number.isFinite(lat));

  if (!coords.length) {
    throw new Error('No GPX track points found');
  }

  return coords;
}

function parseKmlText(text) {
  const xml = new DOMParser().parseFromString(text, 'application/xml');
  const coordinateNodes = [...xml.getElementsByTagName('coordinates')];
  const longest = coordinateNodes
    .map((node) => node.textContent?.trim() || '')
    .sort((a, b) => b.length - a.length)[0];
  const coords = extractCoordinatePairs(longest || '');

  if (!coords.length) {
    throw new Error('No KML line coordinates found');
  }

  return coords;
}

function filenameToTitle(filename) {
  return filename
    .replace(/\.[^.]+$/, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase()) || 'Custom Route';
}

function buildCustomPreset(file, coords) {
  const distanceKm = calculateRouteDistance(coords);
  return {
    id: `custom_${slugify(file.name)}_${coords.length}`,
    name: filenameToTitle(file.name),
    city: 'Custom',
    country: 'Uploaded route',
    subtitle: `${formatDistance(distanceKm)} custom route`,
    date: 'Custom upload',
    distanceKm,
    description: `Uploaded from ${file.name}. This route stays local to this browser session.`,
    suggestedThemes: ['architect_draft', 'shadow_lines', 'soft_neutral'],
    coordinates: coords,
    isCustom: true,
    sourceFilename: file.name,
  };
}

function compactCoordinates(coords, limit = 500) {
  if (!Array.isArray(coords) || !coords.length) return [];
  if (coords.length <= limit) {
    return coords.map(([lon, lat]) => [Number(lon.toFixed(6)), Number(lat.toFixed(6))]);
  }

  const step = Math.max(1, Math.floor(coords.length / limit));
  const sampled = [];
  for (let i = 0; i < coords.length; i += step) {
    sampled.push(coords[i]);
  }
  const last = coords[coords.length - 1];
  if (sampled[sampled.length - 1] !== last) sampled.push(last);
  return sampled.slice(0, limit).map(([lon, lat]) => [Number(lon.toFixed(6)), Number(lat.toFixed(6))]);
}

function mapPaddingToRatio(padding) {
  const minPx = 32;
  const maxPx = 170;
  const minRatio = 0.04;
  const maxRatio = 0.22;
  const clamped = Math.min(maxPx, Math.max(minPx, Number(padding) || minPx));
  const progress = (clamped - minPx) / (maxPx - minPx);
  return Number((minRatio + progress * (maxRatio - minRatio)).toFixed(4));
}

function captureOrderState() {
  const orientation = document.querySelector('.orient-btn.active')?.dataset.orient || 'landscape';
  return {
    v: 1,
    kind: 'marathon',
    presetId: currentPreset.isCustom ? null : currentPreset.id,
    route: currentPreset.isCustom ? {
      id: currentPreset.id,
      name: currentPreset.name,
      subtitle: currentPreset.subtitle,
      date: currentPreset.date,
      distanceKm: currentPreset.distanceKm,
      sourceFilename: currentPreset.sourceFilename || '',
      coordinates: compactCoordinates(currentPreset.coordinates),
    } : null,
    themeId: currentTheme.id,
    routeStyle: {
      color: routeStyle.color,
      width: routeStyle.width,
      glow: routeStyle.glow,
      padding: routeStyle.padding,
      showSplits: routeStyle.showSplits,
      generatorPadding: mapPaddingToRatio(routeStyle.padding),
      generatorContextPadding: Number((mapPaddingToRatio(routeStyle.padding) + 0.1).toFixed(4)),
    },
    typography: {
      font: typography.font,
      color: typography.color,
    },
    details: {
      title: els.eventTitle.value.trim() || currentPreset.name,
      subtitle: els.eventSubtitle.value.trim() || `${currentPreset.subtitle} | ${currentPreset.date}`,
      runner: els.runnerName.value.trim() || 'Runner Name',
      bib: els.bibNumber.value.trim(),
      finish: els.finishTime.value.trim(),
      charity: els.charityName.value.trim(),
      distanceUnit,
    },
    layout: {
      sizeLabel: currentSize.label,
      widthCm: currentSize.w,
      heightCm: currentSize.h,
      orientation,
    },
  };
}

function encodeOrderState() {
  return btoa(unescape(encodeURIComponent(JSON.stringify(captureOrderState()))))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

async function handleRouteUpload(event) {
  const [file] = event.target.files || [];
  if (!file) return;

  try {
    const text = await file.text();
    const suffix = file.name.split('.').pop()?.toLowerCase();
    let coords;

    if (suffix === 'gpx') {
      coords = parseGpxText(text);
    } else if (suffix === 'kml') {
      coords = parseKmlText(text);
    } else {
      throw new Error('Please upload a GPX or KML route file');
    }

    if (coords.length < 2) {
      throw new Error('That route file did not contain enough points');
    }

    customPreset = buildCustomPreset(file, coords);
    renderPresetOptions();
    setRoutePreset(customPreset.id);
    showStatus(`Uploaded ${customPreset.name}`);
  } catch (error) {
    console.error(error);
    showToast(error.message || 'Could not read that route file');
    els.routeUpload.value = '';
  }
}

function clearUploadedRoute() {
  if (!customPreset) return;

  const fallbackId = Object.keys(MARATHON_LIBRARY)[0];
  const wasCustom = currentPreset.isCustom;
  customPreset = null;
  els.routeUpload.value = '';
  renderPresetOptions();

  if (wasCustom) {
    setRoutePreset(fallbackId);
  } else {
    updateUploadUi();
  }

  showStatus('Uploaded route cleared');
}

function buildOrderSummary() {
  return [
    `Poster: ${els.eventTitle.value.trim() || currentPreset.name}`,
    `Route: ${currentPreset.name}`,
    `Theme: ${currentTheme.name}`,
    `Size: ${currentSize.label} (${currentSize.w}×${currentSize.h}cm)`,
    `Orientation: ${document.querySelector('.orient-btn.active')?.dataset.orient || 'landscape'}`,
    `Distance display: ${getDistanceUnitConfig().label}`,
    `Runner: ${els.runnerName.value.trim() || 'Runner Name'}`,
    els.bibNumber.value.trim() ? `Bib: ${els.bibNumber.value.trim()}` : null,
    els.finishTime.value.trim() ? `Finish time: ${els.finishTime.value.trim()}` : null,
    els.charityName.value.trim() ? `Charity: ${els.charityName.value.trim()}` : null,
    currentPreset.isCustom
      ? 'Preview link: custom uploads stay local in this browser'
      : `Theme link: ${location.href}`,
  ].filter(Boolean).join('\n');
}

async function shareState() {
  if (currentPreset.isCustom) {
    showToast('Custom uploads stay local for now');
    return;
  }
  const url = `${location.origin}${location.pathname}#${encodeState()}`;
  try {
    await navigator.clipboard.writeText(url);
    showToast('Link copied');
  } catch (_) {
    showToast(url);
  }
}

async function buyPoster() {
  const btn = els.buyBtn;
  const original = btn.innerHTML;
  btn.textContent = 'Adding to cart…';
  btn.disabled = true;
  try {
    const encodedState = encodeOrderState();
    if (encodedState.length > 60000) {
      throw new Error('This route is too detailed to save safely to checkout. Try a built-in preset or contact support.');
    }

    const handle = `${currentTheme.id.replace(/_/g, '-')}-city-map`;
    const prodRes = await fetch(`${location.origin}/products/${handle}.js`);
    if (!prodRes.ok) throw new Error('Product not found');
    const product = await prodRes.json();
    const variant = product.variants.find((v) =>
      v.title === currentSize.label || v.option1 === currentSize.label
    ) || product.variants[0];

    const properties = {
      'Poster_Type': 'Marathon Route Poster',
      'Preset_ID': currentPreset.isCustom ? '' : currentPreset.id,
      'Route': currentPreset.name,
      'Theme': currentTheme.name,
      'Theme_ID': currentTheme.id,
      'Size': `${currentSize.label} (${currentSize.w}×${currentSize.h}cm)`,
      'Orientation': document.querySelector('.orient-btn.active')?.dataset.orient || 'landscape',
      'Distance_Display': getDistanceUnitConfig().label,
      'Event_Title': els.eventTitle.value.trim() || currentPreset.name,
      'Event_Subtitle': els.eventSubtitle.value.trim() || `${currentPreset.subtitle} | ${currentPreset.date}`,
      'Runner': els.runnerName.value.trim() || 'Runner Name',
      'Bib': els.bibNumber.value.trim(),
      'Finish_Time': els.finishTime.value.trim(),
      'Charity': els.charityName.value.trim(),
      'Font': typography.font,
      'Text_Colour': typography.color || '',
      'Route_Colour': routeStyle.color || '',
      'Route_Width': String(routeStyle.width),
      'Route_Glow': String(routeStyle.glow),
      'Route_Padding': String(routeStyle.padding),
      'Show_Splits': routeStyle.showSplits ? 'true' : 'false',
      'Marathon_State': encodedState,
      'Custom_Route_File': currentPreset.isCustom ? currentPreset.sourceFilename || '' : '',
      'Preview_URL': currentPreset.isCustom
        ? 'Custom route uploaded locally in browser session'
        : `${location.origin}${location.pathname}#${encodeState()}`,
    };

    const cartRes = await fetch(`${location.origin}/cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variant.id, quantity: 1, properties }),
    });
    if (!cartRes.ok) throw new Error('Cart add failed');
    window.location.href = `${location.origin}/checkout`;
  } catch (error) {
    console.warn(error);
    btn.innerHTML = original;
    btn.disabled = false;
    alert(error.message || 'Sorry, something went wrong. Please try again or email piggerystudio@gmail.com');
  }
}

async function enquire() {
  const subject = encodeURIComponent(`Marathon poster enquiry — ${currentPreset.name}`);
  const body = encodeURIComponent(buildOrderSummary());
  window.location.href = `mailto:piggerystudio@gmail.com?subject=${subject}&body=${body}`;
}

function wireInputs() {
  els.routePreset.addEventListener('change', () => setRoutePreset(els.routePreset.value));
  els.routeUpload.addEventListener('change', handleRouteUpload);
  els.routeUploadClear.addEventListener('click', clearUploadedRoute);

  [els.eventTitle, els.eventSubtitle].forEach((input) => {
    input.addEventListener('input', () => {
      input.dataset.userEdited = 'true';
      updateOverlay();
      scheduleHashUpdate();
    });
  });

  [els.runnerName, els.bibNumber, els.finishTime, els.charityName].forEach((input) => {
    input.addEventListener('input', () => {
      updateOverlay();
      scheduleHashUpdate();
    });
  });

  els.fontSelect.addEventListener('change', () => {
    typography.font = els.fontSelect.value;
    updateOverlay();
    scheduleHashUpdate();
  });

  els.textColor.addEventListener('input', () => {
    typography.color = els.textColor.value;
    updateOverlay();
    scheduleHashUpdate();
  });

  els.textColorReset.addEventListener('click', () => {
    typography.color = null;
    els.textColor.value = currentTheme.text;
    updateOverlay();
    scheduleHashUpdate();
  });

  els.routeColor.addEventListener('input', () => {
    routeStyle.color = els.routeColor.value;
    updateRoutePaint();
    scheduleHashUpdate();
  });

  els.routeColorReset.addEventListener('click', () => {
    routeStyle.color = null;
    els.routeColor.value = currentTheme.route_color || '#e53935';
    updateRoutePaint();
    scheduleHashUpdate();
  });

  els.routeWidth.addEventListener('input', () => {
    routeStyle.width = Number(els.routeWidth.value);
    els.routeWidthVal.textContent = formatNumber(routeStyle.width, 2);
    updateRoutePaint();
    scheduleHashUpdate();
  });

  els.routeGlow.addEventListener('input', () => {
    routeStyle.glow = Number(els.routeGlow.value);
    els.routeGlowVal.textContent = formatNumber(routeStyle.glow, 1);
    updateRoutePaint();
    scheduleHashUpdate();
  });

  els.routePadding.addEventListener('input', () => {
    routeStyle.padding = Number(els.routePadding.value);
    els.routePaddingVal.textContent = formatNumber(routeStyle.padding, 0);
    fitRoute();
    scheduleHashUpdate();
  });

  els.showSplits.addEventListener('change', () => {
    routeStyle.showSplits = els.showSplits.checked;
    updateRouteSources();
    updateRoutePaint();
    scheduleHashUpdate();
  });

  els.distanceUnit.addEventListener('change', () => {
    distanceUnit = els.distanceUnit.value || 'miles';
    updateDistanceUi();
    updateRouteSources();
    updateOverlay();
    scheduleHashUpdate();
  });

  document.querySelectorAll('.orient-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.orient-btn').forEach((item) => item.classList.remove('active'));
      btn.classList.add('active');
      updateLayout();
      scheduleHashUpdate();
    });
  });

  document.querySelectorAll('.size-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.size-btn').forEach((item) => item.classList.remove('active'));
      btn.classList.add('active');
      currentSize = {
        label: btn.dataset.label,
        w: Number(btn.dataset.w),
        h: Number(btn.dataset.h),
        ratio: Number(btn.dataset.ratio),
      };
      updateLayout();
      scheduleHashUpdate();
    });
  });

  els.shareBtn.addEventListener('click', shareState);
  els.buyBtn.addEventListener('click', buyPoster);
  els.enquireBtn.addEventListener('click', enquire);
  els.downloadBtn.addEventListener('click', downloadPreview);
}

function init() {
  renderPresetOptions();
  restoreState();
  renderThemeGrid();
  highlightTheme();
  wireInputs();
  els.routeColor.value = routeStyle.color || currentTheme.route_color || '#e53935';
  els.routeWidthVal.textContent = formatNumber(routeStyle.width, 2);
  els.routeGlowVal.textContent = formatNumber(routeStyle.glow, 1);
  els.routePaddingVal.textContent = formatNumber(routeStyle.padding, 0);
  els.textColor.value = typography.color || currentTheme.text;
  els.fontSelect.value = typography.font;
  updateDistanceUi();
  setRoutePreset(currentPreset.id, false);
  renderMap();
}

init();
